import React from 'react';
// import dateFns from 'date-fns';
import * as dateFns from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import classNames from 'classnames';

import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';

import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

const styles = theme => ({
  actionButtons: {
    margin: 'auto',
  },
  action: {
    cursor: 'pointer',
    margin: 'auto',
    color: '#537ccd',
  },
  basis50: {
    flexBasis: '50%',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
  dense: {
    marginTop: 19,
    marginLeft: 0,
  },
  timeInputContainer: {
    flexDirection: 'column',
    marginTop: '20px',
  },
  timeSpan: {
    color: '#0000008a',
  },
  timeInput: {
    marginLeft: '10px',
  },
  typeIn: {
    color: 'black',
    // color: '#00b100',

  },
  typeOut: {
    color: 'black',
    // color: '#ef9a00',
  },
  dayHours: {
    marginBottom: '15px',
  },
  actionDisabled: {
    color: 'gray',
    cursor: 'default',
  },
  listContainer: {
    margin: 'auto',
  },
  root: {
    width: '100%',
  },
  hide: {
    display: 'none !important',
  },
});

class DayHours extends React.Component {
  state = {
    open: false,
    newTime: '',
    justification: '',
    pontoSelecionado: {},
    openRemove: false,
    selectedPanel: null,
    action: '',
  };

  componentWillReceiveProps(nextProps) {
    this.closePanel();
  }

  isBeingEdit = (ponto) => {
    const { actions } = this.props;
    return actions.filter(action => action.id === ponto.id).length;
  }

  edit = (ponto) => {
    this.setState({
      open: true, newTime: '', justification: '', pontoSelecionado: ponto,
    });
  }

  closePanel = () => {
    this.setState({ selectedPanel: null });
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = (event) => {
    this.setState({ newTime: event.target.value });
  }

  handleJustificationChange = (event) => {
    this.setState({ justification: event.target.value });
  }

  openPanel = (ponto, index, action) => {
    if (!this.props.blockActions) {
      this.setState({
        newTime: '',
        justification: '',
        pontoSelecionado: ponto,
        selectedPanel: ((index === this.state.selectedPanel) && (action === this.state.action) ? null : index),
        action,
      });
    }
  }

  aprovePoint = (ponto, index, action) => {

    if (!this.props.blockActions) {
      this.setState({
        pontoSelecionado: ponto,
        action,
      });
      this.confirmAprove(ponto);
    }
  }

  disaprovePoint = (ponto, index, action) => {
    if (!this.props.blockActions) {
      this.setState({
        pontoSelecionado: ponto,
        action,
      });
      this.confirmRemoveOff(ponto);
    }
  }

  handleRemoveClose = () => {
    this.setState({ openRemove: false });
  };

  confirmRemoval = () => {
    const { pontoSelecionado } = this.state;
    pontoSelecionado.newJustification = this.state.justification;
    this.setState({ pontoSelecionado });
    this.props.remove(this.state.pontoSelecionado);
    this.isBeingEdit(this.state.pontoSelecionado);
    this.closePanel();
  }

  confirmRemoveOff = (ponto) => {
    ponto.newJustification = 'Ponto offline recusado';
    this.props.remove(ponto);
    this.isBeingEdit(ponto);
  }

  confirmAprove = (ponto) => {
    this.props.aprove(ponto);
    this.isBeingEdit(ponto);
  }

  undoAction = (ponto) => {
    this.props.undoAction(ponto);
  }

  renderConfirmRemoval = () => {
    const { classes } = this.props;
    return (
      <div>
        <Typography>
          O ponto será inativado. Informe uma justificativa para continuar.
        </Typography>
        <span className={classNames(classes.timeInputContainer, 'display-flex')}>
          <TextField
            required
            label="Justificativa"
            value={this.state.justification}
            onChange={this.handleJustificationChange}
            className={classNames(classes.textField, classes.dense)}
            margin="dense"
          />
        </span>
        <Button
          variant="contained"
          color="primary"
          disabled={!this.state.justification.length}
          onClick={() => this.confirmRemoval()}
        >
          CONFIRMAR
        </Button>
      </div>
    );
  }

  renderEdit = () => {
    const { classes } = this.props;
    return (
      <div>
        <Typography>
          Informe o novo horário e uma justificativa.
        </Typography>
        <span className={classNames(classes.timeInputContainer, 'display-flex')}>
          <span className={classNames(classes.basis50, classes.timeSpan)}>
          Novo horário:
            <input
              className={classes.timeInput}
              type="time"
              value={this.state.newTime}
              onChange={this.handleChange}
            />
          </span>

          <TextField
            required
            label="Justificativa"
            value={this.state.justification}
            onChange={this.handleJustificationChange}
            className={classNames(classes.textField, classes.dense)}
            margin="dense"
          />
        </span>

        <Button
          disabled={!this.state.justification.length || !this.state.newTime.length}
          variant="contained"
          color="primary"
          onClick={() => this.confirmEdit()}
        >
          CONFIRMAR
        </Button>
      </div>
    );
  }

  confirmReactivation = () => {
    const { pontoSelecionado } = this.state;
    pontoSelecionado.newJustification = this.state.justification;
    this.setState({ pontoSelecionado });
    this.props.remove(this.state.pontoSelecionado);
    this.isBeingEdit(this.state.pontoSelecionado);
    this.closePanel();
  }

  renderReactivate = () => {
    const { classes } = this.props;
    return (
      <div>
        <Typography>
          Informe uma justificativa para reativar o ponto.
        </Typography>
        <span className={classNames(classes.timeInputContainer, 'display-flex')}>
          <TextField
            required
            label="Justificativa"
            value={this.state.justification}
            onChange={this.handleJustificationChange}
            className={classNames(classes.textField, classes.dense)}
            margin="dense"
          />
        </span>

        <Button
          disabled={!this.state.justification.length}
          variant="contained"
          color="primary"
          onClick={() => this.confirmReactivation()}
        >
          CONFIRMAR
        </Button>
      </div>
    );
  }

  createData = (a) => {
    a.data = dateFns.format(this.fixTimestamp(a.dtRegister), 'HH:mm');

    return a;
  }

  fixTimestamp(date) {
    return new Date(new Date(date).getTime() + (new Date(date).getTimezoneOffset() * 60000));
  }

  rows = [];
  mountRows = () => {
    if (this.props.hours) {
      this.rows = this.props.hours.map(a => this.createData(a));
    }
  }

  renderHours2 = (hours) => {
    const { classes } = this.props;

    this.mountRows();

    return (
      <Paper elevation={2} className={classNames(classes.listContainer)}>
        {/* <Table className={classes.table}> */}
        <Table style={{ tableLayout: 'fixed' }}>

          <TableHead>
            <TableRow>
              <TableCell >Horário</TableCell>
              {/* <TableCell align="center">Referência</TableCell> */}
              <TableCell />
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody data-tut="reactour__edit">
            {this.rows.map((row, index) => (
              <ExpansionPanel elevation={2} expanded={this.expandPanel(index)} style={{ width: '300%', margin: '0px 0px' }}>

                <TableRow component="tr" key={row.id} style={{ background: row.category === 'REM' ? '#a9a9a9a1' : '', display: 'flex', flex: 1 }}>
                  <TableCell
                    component="th"
                    scope="row"
                    align="center"
                    style={{
 padding: '0', display: 'flex', minHeight: '48px', alignItems: 'center', justifyContent: 'center', width: '70%', marginRight: '20%',
}}
                    className={`${row.type === 'I' ? classes.typeIn : classes.typeOut}`}
                  >
                    {row.data}
                  </TableCell>
                  {/* <TableCell align="center">{row.referencia}</TableCell> */}
                  {/* <TableCell style={{ padding: '0' }} align="center">{row.isRemake ? (row.category === 'REM' ? 'Funcionário' : 'Gestor') : 'Funcionário'}</TableCell> */}
                  <TableCell style={{
padding: '0', display: 'flex', flex: 1,
}}
                  />
                  <TableCell
                    align="center"
                    style={{
display: 'flex', minHeight: '48px', alignItems: 'center', padding: '0', width: '70%', marginLeft: '22%',
}}
                  >
                    <Tooltip
                      className={classNames(`${this.isBeingEdit(row) || row.category === 'REM' ? this.props.classes.hide : ''}`)}
                      title="Aprovar Ponto"
                      aria-label="Editar Ponto"
                      placement="top"
                    >
                      <Icon
                        onClick={() => { if (!this.isBeingEdit(row)) this.aprovePoint(row, index, 'OFF'); }}
                        className={classNames(this.props.classes.action, `${this.isBeingEdit(row) ? this.props.classes.actionDisabled : ''}`)}
                      >
                          done
                      </Icon>
                    </Tooltip>

                    <Tooltip title="Recusar Ponto" aria-label="Inativar Ponto" placement="top" className={classNames(`${this.isBeingEdit(row) || row.category === 'REM' ? this.props.classes.hide : ''}`)}>
                      <Icon
                        onClick={() => { if (!this.isBeingEdit(row)) this.disaprovePoint(row, index, 'remove'); }}
                        className={classNames(this.props.classes.action, `${this.isBeingEdit(row) ? this.props.classes.actionDisabled : ''}`)}
                      >
                          clear
                      </Icon>
                    </Tooltip>

                    <Tooltip title="Reativar Ponto" aria-label="Reativar Ponto" placement="top" className={classNames(`${this.isBeingEdit(row) || (row.category !== 'REM') ? this.props.classes.hide : ''}`)}>
                      <Icon
                        onClick={() => { if (!this.isBeingEdit(row)) this.openPanel(row, index, 'reactivate'); }}
                        className={classNames(this.props.classes.action)}
                      >
                          update
                      </Icon>
                    </Tooltip>

                    <Tooltip title="Desfazer" aria-label="Desfazer" placement="top" className={classNames(`${!this.isBeingEdit(row) ? this.props.classes.hide : ''}`)}>
                      <Icon
                        onClick={() => { if (this.isBeingEdit(row)) this.undoAction(row); }}
                        className={classNames(this.props.classes.action, `${!this.isBeingEdit(row) ? this.props.classes.actionDisabled : ''}`)}
                      >
                          undo
                      </Icon>
                    </Tooltip>
                  </TableCell>
                </TableRow>


                <ExpansionPanelDetails>
                  {this.rederPanelContent()}
                </ExpansionPanelDetails>

              </ExpansionPanel>
              ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
  expandPanel = index => index === this.state.selectedPanel

  rederPanelContent = () => {
    if (this.state.action === 'remove') {
      return this.renderConfirmRemoval();
    }

    if (this.state.action === 'edit') {
      return this.renderEdit();
    }

    if (this.state.action === 'reactivate') {
      return this.renderReactivate();
    }

    return (<span>selecione alguma ação</span>);
  }

  confirmEdit = () => {
    const currentDate = new Date(this.state.pontoSelecionado.dtRegister);
    const ano = dateFns.getYear(currentDate);
    const mes = dateFns.getMonth(currentDate);
    const dia = dateFns.getDate(currentDate);
    const hora = this.state.newTime.slice(0, 2);
    const minuto = this.state.newTime.slice(3, 5);
    const newDT = new Date(ano, mes, dia, hora, minuto);
    const { pontoSelecionado } = this.state;
    pontoSelecionado.newDT = newDT;
    pontoSelecionado.newJustification = this.state.justification;
    this.setState({ pontoSelecionado });
    this.props.edit(this.state.pontoSelecionado);
    this.handleClose();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.dayHours}>
        {this.renderHours2()}
        <Dialog // Dialog Edição
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">Editar Ponto</DialogTitle>
          <DialogContent>
            <DialogContentText>
            Informe o novo horário para o ponto correspondente a&nbsp;{this.state.pontoSelecionado.dtRegister && dateFns.format(new Date(this.state.pontoSelecionado.dtRegister), 'HH:mm')}.
            </DialogContentText>

            <div className={classNames(classes.timeInputContainer, 'display-flex')}>
              <span className={classNames(classes.basis50, classes.timeSpan)}>
                Novo horário:
                <input
                  className={classes.timeInput}
                  type="time"
                  value={this.state.newTime}
                  onChange={this.handleChange}
                />
              </span>

              <TextField
                required
                label="Justificativa"
                value={this.state.justification}
                onChange={this.handleJustificationChange}
                className={classNames(classes.textField, classes.dense)}
                margin="dense"
              />
            </div>

          </DialogContent>
          <DialogActions>
            <Button
              disabled={!this.state.justification.length || !this.state.newTime.length}
              variant="contained"
              color="primary"
              onClick={() => this.confirmEdit()}
            >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(DayHours);
